import React, { useContext } from 'react';
import { Tooltip } from 'antd';
import { ThemeContext } from 'pages/_app';
import styles from './editor-button.module.css';

type EditorButtonProps = {
  callback: () => void;
  toolTipMessage: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export function EditorButton({
  callback,
  toolTipMessage,
  children,
  className = '',
  disabled = false,
}: EditorButtonProps) {
  const { isDark } = useContext(ThemeContext);

  return (
    <Tooltip placement='top' title={toolTipMessage}>
      <button
        className={`${styles.root} ${className} ${
          isDark ? styles.darkTheme : ''
        }`}
        onClick={callback}
        disabled={disabled}
        type='button'
      >
        {children}
      </button>
    </Tooltip>
  );
}
